/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index drawer to autogenerate all the components and extensions
 * Used by "prepareDrawers"
 */

import Drawer from './drawer/Drawer'
export * from './drawer/Drawer'
export default Drawer
